import { get } from 'svelte/store';

import { dla } from './DeliveryListApp/dla';
import { deliveryList } from '../../../../stores/store';
import { AssignmentJob } from "../AssignmentJob";
import { Assignment } from "../Assignment";
import { DeliveriesMenuActions } from './DeliveriesMenuActions';
import { rsa } from './RouteSummaryApp/rsa';
import { object } from 'zod';

export function setAssignmentJobMenu(assignmentJob: AssignmentJob, assignment: Assignment, handler?: (action: string, end: boolean, aj: AssignmentJob) => void): AssignmentJob {

    function updateRouteSummary() {
        setTimeout(() => {
            rsa.set(get(rsa).startLoading());
            get(rsa).reload(assignment)
                .then(ass => {
                    assignment = ass;
                })
                .catch(err => {
                    console.error('Cannot upload estimate rsa');
                })
                .finally(() => {
                    rsa.set(get(rsa).stopLoading());
                });
        }, 0);
    }

    function resetBulkActionSelection() {
        deliveryList.set({...get(deliveryList), selectedOrUnselected: [], selectMode: 'selected'});
    }

    function updateDeliveryListDisplayedAssignment() {
        deliveryList.update(dl => {
            return {...dl, displayedAssignmentJobDetails: get(dla)
                .getFilteredItems()
                .map((aj: any) => {
                    return {
                        jobId: aj.getJobId(),
                        hasAssignment: DeliveriesMenuActions.hasAssignment(aj),
                        hasSuggestion:
                            aj.getSuggestedAssignmentId() === assignment.getId(),
                        hasAdhoc: aj.isAdHoc(),
                        canBeRejected: DeliveriesMenuActions.deliveryCanBeRejected(
                            aj,
                            assignment
                        ),

                        canBeAssigned: DeliveriesMenuActions.deliveryCanBeAssigned(
                            aj,
                            assignment
                        ),
                    };
                })
            }
        });
    }

    let handlers: Record<string, Function> = {
        assign_to_last_used: async function(done: boolean = true) {
            if (done) {
                if (handler) {
                    handler('assign_to_last_used', false, assignmentJob);
                }
                get(dla).getMapModule()?.jobReassign(
                    assignmentJob.getJobId(),
                    assignmentJob.getAssignmentId(),
                    assignmentJob.getId()
                );

                if (
                    !assignment.isDefault() ||
                    assignment.getId() !== assignmentJob.getAssignmentId()
                ) {
                    get(dla).removeItem(assignmentJob.getJobId());
                    dla.set(get(dla));
                }
                updateRouteSummary();
                if (handler) {
                    handler('assign_to_last_used', true, assignmentJob);
                }
            }
        },
        assign: async function(done: boolean = true) {
            if (done) {
                if (handler) {
                    handler('assign', false, assignmentJob);
                }
                dla.set(get(dla).updateAssignmentJob(assignmentJob));
                get(dla).getMapModule()?.jobReassign(
                    assignmentJob.getJobId(),
                    assignmentJob.getAssignmentId(),
                    assignmentJob.getId()
                );

                updateDeliveryListDisplayedAssignment();
                updateRouteSummary();
                resetBulkActionSelection();
                if (handler) {
                    handler('assign', true, assignmentJob);
                }
            }
        },
        assign_suggestion: async function(done: boolean = true) {
            if (done) {
                if (handler) {
                    handler('assign_suggestion', false, assignmentJob);
                }
                dla.set(get(dla).updateAssignmentJob(assignmentJob));
                get(dla).getMapModule()?.jobReassign(
                    assignmentJob.getJobId(),
                    assignmentJob.getAssignmentId(),
                    assignmentJob.getId()
                );

                updateDeliveryListDisplayedAssignment();
                updateRouteSummary();
                resetBulkActionSelection();
                if (handler) {
                    handler('assign_suggestion', true, assignmentJob);
                }
            }
        },
        select_another_assignment: async function(done: boolean = true) {
            if (done) {
                if (handler) {
                    handler('select_another_assignment', false, assignmentJob);
                }
                updateRouteSummary();
                resetBulkActionSelection();
                dla.set(get(dla).updateAssignmentJob(assignmentJob));
                if (
                    !assignment.isDefault() ||
                    assignment.getId() !== assignmentJob.getAssignmentId()
                ) {
                    console.log(
                        '_reload, selectAnotherAssignment',
                        assignment.getId(),
                        assignmentJob.getAssignmentId()
                    );
                    get(dla).removeItem(assignmentJob.getJobId());
                    dla.set(get(dla));
                }
                if (handler) {
                    handler('select_another_assignment', true, assignmentJob);
                }
                console.log(
                    '_reload, selectAnotherAssignment, ModalSelectRoute onClick return exit',
                    assignment.getId(),
                    assignmentJob.getAssignmentId()
                );
            }
        },
        reject: async function(done: boolean = true) {
            if (done) {
                if (handler) {
                    handler('reject', false, assignmentJob);
                }
                try {
                    get(dla).getMapModule()?.jobReassign(assignmentJob.getJobId(), 0, null);
                    assignment = await assignment.reload();
                    get(dla).removeItem(assignmentJob.getJobId());
                } catch (e) {
                    console.error(e);
                }
                dla.set(get(dla));
                resetBulkActionSelection();
                updateRouteSummary();
                if (handler) {
                    handler('reject', true, assignmentJob);
                }
            }
        }
    };
    handlers.change_target_date = handlers.reject;

    assignmentJob.setMenuOptions(assignment, handlers);

    return assignmentJob;
}